<div class="grid-container margin-top">
  <div class="grid-x">

    @if (gridReady) {
      <div class="cell large-12 medium-12 small-12">
        <ag-grid-angular class="data-grid  full-page"
        [gridOptions]="gridOptions" [excelStyles]="excelStyles" aria-label="Wells Requiring Bonding Insurance Report"></ag-grid-angular>
      </div>
    }

  </div>
</div>